/**
 * @param {Number} code
 * @returns {Boolean}
 */
export function isError4xx(code) {
  if (typeof code !== 'number' || isNaN(code)) {
    return false; // или можно выбрать другое значение в зависимости от требований
  }

  return code >= 400 && code < 500;
}

/**
 * Устанавливает `location.state.appStatus` _на клиенте_
 *
 * @param {Object} history Объект `history` из react-router
 * @param {*} appStatus значение, которое нужно установить в `location.state.appStatus`
 */
export function setAppStatus(history, appStatus) {
  if (process.env.BROWSER_RUNTIME) {
    history.replace({
      ...history.location,
      state: {
        appStatus,
      },
    });
  }
}

/**
 * Устанавливает приложению на клиенте статус 'offline'
 *
 * @param {Error} error
 * @param {Object} history Объект `history` из react-router
 * @returns {Promise} rejected promise с переданной ошибкой
 */
export function renderOffline(error, history) {
  if (!error.response) {
    setAppStatus(history, 'offline');
  }

  return Promise.reject(error);
}


/**
 * Устанавливает значения, необходимые для того, чтобы приложение отрендерило
 * страницу ошибки
 *
 * @param {Error} error
 * @param {Object} history Объект `history` из react-router
 * @returns {Promise} rejected promise с переданной ошибкой
 */
export function renderError(error, history) {
  setAppStatus(history, error?.statusCode || error?.response?.status || 'offline');

  return Promise.reject(process.env.NODE_ENV
    // Для SSR добавляем признак того, что надо показать страницу с ошибкой
    ? Object.assign(error, { shouldRenderError: true })
    : error
  );
}
